<script>
    import {shoppingCart, showShoppingCart} from "../../js/stores";
    import {link} from 'svelte-spa-router'
    import {API_URL} from "../../../env";
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher()

    let canAdd = true

    export let data = {
        // amount: 0,
        // product_id: 0,
        // variant: 0,
        // price: 0,
        // product: {
        //     "id": null,
        //     "name": "",
        //     "profile": "",
        //     "diameter": "",
        //     "season": "",
        //     "picture": "",
        //     "manufacturer": "",
        //     "manufacturer_logo": null
        // }
    }

    let maximum = (data.stock > 0)? data.stock : 99

    function chooseSeasonText(season) {
        switch (season) {
            case 'Letní':
                return '/assets/img/icons/sun.svg'
            case 'Zimní':
                return '/assets/img/icons/snowflake.svg'
            case 'Celoroční':
                return '/assets/img/icons/wholeyear.svg'
            default:
                return ''
        }
    }

    /*************************************************/

    async function handleRemoveItem() {
        let body = {
            id: data.id
        }

        const res = await fetch(API_URL + '/shoppingCart/remove', {
            method: 'DELETE',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            console.error('Remove item from shopping cart fetch error!', await res.json())
            return
        }

        shoppingCart.set($shoppingCart.filter(v => v.id !== body.id))
        dispatch('removeItem', {id: data.id})
    }

    /**********************************************************/

    async function handleAmountChange() {
        canAdd = false
        if (!data.amount || data.amount < 1) {
            data.amount = 1
        }
        else if (data.amount > maximum) {
            data.amount = maximum
        }

        let body = {
            id: data.id,
            amount: data.amount
        }

        const res = await fetch(API_URL + '/shoppingCart/update', {
            method: 'PUT',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })

        if (!res.ok) {
            console.error('Update item in shopping cart fetch error!', await res.json())
            canAdd = true
            return
        }

        const decodedRes = await res.json()
        $shoppingCart.find(v => v.id === body.id).amount = decodedRes.find(v => v.id === body.id).amount
        shoppingCart.set($shoppingCart)
        canAdd = true
    }

    function changeAmountPlus() {
        if (!canAdd) return;

        if (data.amount < maximum) {
            canAdd = false
            data.amount++
            handleAmountChange()
        }
    }

    function changeAmountMinus() {
        if (!canAdd) return;

        if (data.amount > 1) {
            canAdd = false
            data.amount--
            handleAmountChange()
        }
    }

    // $: handleAmountChange(data.amount)
</script>

<div class="product">
    <div class="product-image">
        <img src={(data.product?.picture)? data.product?.picture: "/assets/img/nahled.webp"} alt="Fotografia pneumatiky">
    </div>
    <div class="product-text">
        <div class="product-logo">
            {#if data.product?.manufacturer_logo}
                <img src={data.product?.manufacturer_logo} alt="{data.product?.manufacturer}">
            {:else}
                <span>{data.product?.manufacturer}</span>
            {/if}
        </div>
        <div class="product-name"><a use:link href="/produkt/{data.product_id}" on:click={() => showShoppingCart.set(false)}>{data.product?.name}</a></div>
        <div class="product-info">
            <div class="product-details">
                {#if data.product?.season && data.product?.season !== 'Unclassified'}
                    <img src={chooseSeasonText(data.product?.season)} alt="{data.product?.season}">
                {/if}
                <div class="detail-item">{data.product?.width}</div>
                <div class="detail-item">{data.product?.profile}</div>
                <div class="detail-item">R{data.product?.diameter}</div>
            </div>
        </div>
        <div class="product-count">
            <button on:click={() => {changeAmountMinus()}}>-</button>
            <label><input type="number" on:change={handleAmountChange} bind:value={data.amount} min="1" max={maximum}>ks</label>
            <button on:click={() => {changeAmountPlus()}}>+</button>
        </div>
    </div>
    <div class="product-right">
        <div class="product-price">{(data.price * data.amount).toFixed(2)}€</div>
        <div class="product-remove pointer-event" on:click={handleRemoveItem}>odobrať</div>
    </div>
</div>

<style>
    .product {
        display: flex;
        flex-direction: row;
    }
    .product .product-logo {
        display: grid;
        place-items: start;
        height: 2.5rem;
    }
    .product .product-logo img {
        max-width: 8rem;
        max-height: 1.5rem;
    }
    .product .product-logo span {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        font-size: 1.3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .product .product-image {
        width: 6.5rem;
        height: 6.5rem;
        display: grid;
        place-items: center;
        margin-left: 15px;
    }
    .product .product-image img {
        max-width: 6.5rem;
        max-height: 6.5rem;
    }
    .product .product-text {
        margin-left: 1rem;
    }
    .product .product-text .product-name {
        font-family: SegoeUI, sans-serif;
        margin-top: -15px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 250px;
        max-width: 100%;
    }
    .product .product-text .product-name a {
        color: black;
    }
    .product .product-text .product-details {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
        font-family: Rubik, sans-serif;
        font-weight: 500;
        padding: 4px 0;
    }
    .product .product-text .product-details div {
        border-right: 2px solid rgba(0, 0, 0, 0.1);
        font-size: 1rem;
        padding: 0 0.5rem;
    }
    .product .product-text .product-details div:last-child {
        border: 0;
    }
    .product .product-count {
        display: flex;
        flex-direction: row;
    }
    .product .product-count button {
        background-color: #DFDFDF;
        color: black;
        font-size: 1rem;
        transition: 0.2s;
        cursor: pointer;
    }
    .product .product-count button:hover {
        background-color: #B9B9B9;
        transition: 0.2s;
    }
    .product .product-count button:first-child {
        border-radius: 8px 0 0 8px;
        padding: 0.3rem 0.3rem 0.3rem 0.5rem;
    }
    .product .product-count button:last-child {
        border-radius: 0 8px 8px 0;
        padding: 0.3rem 0.5rem 0.3rem 0.3rem;
    }
    .product .product-count input {
        width: 1.7rem;
        font-family: Rubik, sans-serif;
        font-weight: 500;
        padding: 0 0.2rem;
        margin-top: 0.2rem;
        font-size: 1rem;
        text-align: center;
    }
    .product .product-count label {
        font-size: 1rem;
        border: 1px solid #DFDFDF;
        font-family: Rubik, sans-serif;
        font-weight: 500;
        padding-right: 0.5rem;
    }
    .product-right {
        margin-left: auto;
        margin-right: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
    .product-right .product-price {
        font-family: Rubik, sans-serif;
        font-weight: 500;
        color: #303030;
        font-size: 1.4rem;
        margin-top: 2.8rem;
    }
    .product-right .product-remove {
        width: 100%;
        text-align: right;
        color: red;
        text-decoration: underline;
        font-family: Rubik, sans-serif;
        font-weight: 300;
        transition: 0.2s;
    }
    .product-right .product-remove:hover {
        color: #b60000;
        transition: 0.2s;
    }
    @media (max-width: 575.98px) {
        .product .product-image {
            display: none;
        }
        .product .product-text {
            margin-left: 0;
        }
    }
</style>